import { PropsWithClassName } from "shared/props";
import { AuthButtons } from 'shared/auth/Buttons';

import styles from './Buttons.module.scss';

export const AuthSignInButtons = <TProps extends PropsWithClassName>(props: TProps) => {
	return (
		<div className={`${props.className} ${styles.container} flex-container-vertical flex-align-vertical-center`}>
			<h1 className={styles.header}>Вход / регистрация</h1>
			<p className={styles.description}>Использование сайта возможно только при соблюдении пользовательского соглашения.</p>
			<AuthButtons></AuthButtons>
		</div>
	);
}